<template>
  <div>
    <div class="row">
      <volcan-input-checkbox
        class="checkbox-indent"
        v-model="imageLinkCombo.isYoutubeLink"
        :text="isYoutubeLink"
      />
    </div>
    <div class="row">
      <volcan-input-textarea
        v-if="imageLinkCombo.isYoutubeLink"
        v-model="imageLinkCombo.youtubeLink"
        :text="youtubeLink"
        class="col-12"
      />
      <volcan-dropzone
        :hasInfos="false"
        v-if="!imageLinkCombo.isYoutubeLink"
        v-model="imageLinkCombo.image"
        :moduleName="moduleName"
        :options="{
          maxFiles: maxFiles,
          thumbnailHeight: 150,
          thumbnailWidth: 150,
          dictDefaultMessage: dropFile,
          acceptedFiles: acceptedFiles,
        }"
        :text="image"
        class="col-6"
      />
    </div>
  </div>
</template>
<script>
export default {
  name: "volcan-image-link-combo",
  data: function () {
    return {
      id: null,
    };
  },
  props: {
    imageLinkCombo: {
      required: true,
    },
    isYoutubeLink: {
      type: String,
      default() {
        return this.$t("imageLinkCombo.isYoutubeLink");
      },
    },
    youtubeLink: {
      type: String,
      default() {
        return this.$t("imageLinkCombo.youtubeLink");
      },
    },
    dropFile: {
      type: String,
      default() {
        return this.$t("imageLinkCombo.dropFile");
      },
    },
    image: {
      type: String,
      default() {
        return this.$t("imageLinkCombo.image");
      },
    },
    maxFiles: {
      type: Number,
      default: 1,
    },
    acceptedFiles: {
      type: String,
      default: "image/*",
    },
    moduleName: {
      type: String,
      require: true,
    },
  },
};
</script>
<style scoped>
.checkbox-indent {
  margin-left: 15px;
}
</style>



// WEBPACK FOOTER //
// components/AdminTools/divers/image-link-combo.vue